/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { useSelector, useDispatch} from "react-redux";

const Collections = ({ children }) => {
  const { collections, current } = useSelector((state) => state.project);
  return (
    <div className="columns">
      <div
        className="column is-narrow"
      >
        <aside className="menu">
          <ul className="menu-list">
            {collections.map((collection) => (
              <Collection
                key={collection.id}
                current={current}
                collection={collection}
              />
            ))}
          </ul>
        </aside>
      </div>
      <div className="column">
        <div className="box">{children}</div>
      </div>
    </div>
  );
};

export default Collections;

// ------------------------------------------------------
// ------------------------------------------------------

const Collection = ({ collection, current }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  return (
    <li>
      <a
        role="button"
        tabIndex={0}
        className={`${
          current === collection.id ? "is-active" : ""
        } collection-sidebar-wrapper`}
        onClick={ () => {
          dispatch({ type: "SET_CURRENT_COLLECTION", current: collection.id })
        }}
      >
        <span>{collection.title.replace(" ", "\u00a0")}</span>
        <span className="icon is-small" onClick = { evt => {
          evt.stopPropagation();
          setOpen(!open);
        }}>
          <i className={open ? "fa fa-angle-down" : "fa fa-angle-right"} />
        </span>
      </a>
      <ul className="tiny">
        {open ? (
          <>
            <li>
              <a role="button" tabIndex={0}>Tafari_00443925056_2022122_052&nbsp;(2)</a>
            </li>
            <li>
              <a role="button" tabIndex={0}>Tafari_00443925056_2022071_052&nbsp;(4)</a>
            </li>
            <li>
              <a role="button" tabIndex={0}>Tafari_00443925056_2022101_052&nbsp;(2)</a>
            </li>
          </>
        ) : null}
      </ul>
    </li>
  );
};
